module.exports = __webpack_public_path__ + "img/w57b.675d6973.jpg";